import { render, staticRenderFns } from "./recognizePanel.vue?vue&type=template&id=1e1cf9ba&scoped=true&"
import script from "./recognizePanel.vue?vue&type=script&lang=js&"
export * from "./recognizePanel.vue?vue&type=script&lang=js&"
import style0 from "./recognizePanel.vue?vue&type=style&index=0&id=1e1cf9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1cf9ba",
  null
  
)

export default component.exports